<h2 mat-dialog-title>{{'inspectionReportEditTextImportConfirmDialog.Confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'inspectionReportEditTextImportConfirmDialog.MsgImportFile' | translate}}</p>
  <mat-list>
    <mat-list-item>
      <p>{{ data.filename }}</p>
    </mat-list-item>
  </mat-list>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button color="primary" mat-dialog-close>{{'inspectionReportEditTextImportConfirmDialog.No' | translate}}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{'inspectionReportEditTextImportConfirmDialog.Yes' | translate}}</button>
  </mat-dialog-actions>
</div>